import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { StateService } from '../../../services/state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BewerberAdapter } from '../../../adapter/bewerber.adapter';
import * as Sentry from '@sentry/angular';
import { take } from 'rxjs/operators';
import { DatePicker } from 'primeng/datepicker';
import { Button } from 'primeng/button';
import { Fluid } from 'primeng/fluid';
import { VerificationResponseDto } from '../../../adapter/dto/verification-response.dto';

export interface VerifyForm {
  dateOfBirth: FormControl<Date | null>;
}

@Component({
  selector: 'app-vp-verify',
  templateUrl: './vp-verify.component.html',
  styleUrls: ['./vp-verify.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, DatePicker, Button, Fluid]
})
export class VpVerifyComponent {
  protected form: FormGroup<VerifyForm> = new FormGroup<VerifyForm>({
    dateOfBirth: new FormControl<Date | null>(null, {
      validators: [Validators.required]
    })
  });

  public constructor(
    protected readonly stateService: StateService,
    private readonly route: ActivatedRoute,
    private readonly bewerberService: BewerberAdapter,
    private readonly router: Router
  ) {}

  protected verify(): void {
    if (this.form.valid) {
      const token: string | null = this.route.snapshot.paramMap.get('token');
      const birthdate: Date | null = this.form.controls.dateOfBirth.value ?? null;

      if (token === null || birthdate === null) {
        this.stateService.setHasError(true);
        return;
      }

      this.stateService.setIsLoading(true);
      this.stateService.setHasError(false);

      this.bewerberService
        .verify(token, birthdate)
        .pipe(take(1))
        .subscribe({
          next: (verifyResult: VerificationResponseDto): void => {
            Sentry.setUser({ id: token });

            this.stateService.setIsLoading(false);
            this.stateService.setToken(token);
            this.stateService.setVerificationResponse(verifyResult);
            this.stateService.setBirthdate(birthdate);

            this.router.navigate(['/vp', token, 'landing'], { replaceUrl: true });
          },
          error: (error: Error): void => {
            Sentry.setUser({ id: token });
            Sentry.captureEvent(error);
            this.stateService.setIsLoading(false);
            this.stateService.setHasError(true);
          }
        });
    }
  }
}
